// src/Views/Signin/Signin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import './Signin.css';

const Signin = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSignin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            // AuthContext usually handles the redirect, but we can force it here just in case
            navigate('/app'); 
        } catch (err) {
            console.error('Signin error', err);
            let msg = 'Failed to sign in.';
            
            // User-friendly error mapping
            if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
                msg = 'Incorrect email or password.';
            } else if (err.code === 'auth/too-many-requests') {
                msg = 'Too many failed attempts. Please try again later.';
            }
            
            setError(msg);
            setLoading(false);
        }
    };

    return (
        <section className="signin">
            {/* Atmosphere */}
            <div className="signin__bg-glow signin__bg-glow--one" />
            <div className="signin__bg-glow signin__bg-glow--two" />
            <div className="signin__bg-grid" />

            <div className="signin__container">
                <div className="signin__card">
                    
                    {/* Header */}
                    <div className="signin__header">
                        <div className="signin__logo-pill">
                            <Icon icon="solar:shield-check-linear" />
                            <span>Secure Login</span>
                        </div>
                        <h1 className="signin__title">Welcome back</h1>
                        <p className="signin__subtitle">
                            Sign in to access your predictions and workspace.
                        </p>
                    </div>

                    {/* Form */}
                    <form className="signin__form" onSubmit={handleSignin}>
                        
                        {/* Email */}
                        <div className="signin__field-group">
                            <label className="signin__label">Email address</label>
                            <div className="signin__input-wrap">
                                <Icon icon="solar:letter-linear" className="signin__input-icon" />
                                <input
                                    type="email"
                                    className="signin__input"
                                    placeholder="name@example.com"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div className="signin__field-group">
                            <div className="signin__label-row">
                                <label className="signin__label">Password</label>
                                <button 
                                    type="button" 
                                    className="signin__forgot-btn"
                                    onClick={() => navigate('/forgot-password')}
                                >
                                    Forgot password?
                                </button>
                            </div>
                            <div className="signin__input-wrap">
                                <Icon icon="solar:lock-password-linear" className="signin__input-icon" />
                                <input
                                    type="password"
                                    className="signin__input"
                                    placeholder="••••••••"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="signin__error">
                                <Icon icon="solar:danger-triangle-linear" />
                                <span>{error}</span>
                            </div>
                        )}

                        {/* Submit Button */}
                        <button 
                            type="submit" 
                            className="signin__btn signin__btn--primary" 
                            disabled={loading}
                        >
                            {loading ? (
                                <span>Verifying credentials...</span>
                            ) : (
                                <>
                                    <span>Sign In</span>
                                    <Icon icon="solar:login-3-linear" />
                                </>
                            )}
                        </button>
                    </form>

                    {/* Footer */}
                    <div className="signin__footer">
                        <p>Don't have an account? <span onClick={() => navigate('/signup')}>Create one</span></p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Signin;